import React from 'react';
import { Button } from 'reactstrap';
import { useBillingActions, useFlowActions } from '../../../../context';
import { ActionButtonGroup, DowngradeBillingDetailsFooter } from '../../../shared';
import { calculateBillingDates } from '../../../../utils';

/**
 * Component that displays the downgrade offer for users who select "goalAchieved" as their reason
 * Offers a $15/month community-level membership as an alternative to cancellation
 */
const GoalAchievedDowngradeOffer = () => {
  // Get actions from context
  const { switchPlan } = useBillingActions();
  const { cancelAnyway } = useFlowActions();
  const { formattedNextBillingDate } = calculateBillingDates();
  return (
    <div className="goal-achieved-downgrade-offer-content">
      <div className="mb-4">
        <h5 className="mb-3">Congratulations on reaching your goal!</h5>
        <p className="mb-3">
          That's truly something to celebrate. We're honored that WHOLE Life Club was part of your journey — and we're
          cheering you on as you continue to thrive.
        </p>
        <p className="mb-3">
          If you're feeling complete and ready to move on, you can go ahead and cancel below. No pressure at all.
        </p>
        <p className="mb-3">
          But if you'd like to stay connected — just to keep the inspiration flowing — we'd love to offer you a{' '}
          <strong>community-level membership for $15/month</strong>. You see, we love having successful folks in our
          community!
        </p>
        <p className="mb-3">And this way, you'll still get:</p>

        <div className="mb-4">
          <ul className="list-unstyled mb-0">
            <li className="mb-2">🥗 Access to our recipe library</li>
            <li className="mb-2">🎓 Expert-led lessons and seasonal challenges</li>
            <li className="mb-2">🌱 Wellness Buddy support</li>
            <li className="mb-2">💬 A vibrant community of like-minded folks</li>
          </ul>
        </div>

        <p className="mb-3">
          It's a gentle way to stay in the loop and keep your momentum going, even if you don't need much right now.
        </p>

        <p className="mb-4">
          Whatever you choose, thank you for being part of the FRN community. You inspire us! And we wish you continued
          health and joy.
        </p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Switch to $15/month Plan',
            onClick: switchPlan,
            color: 'primary',
            className: 'mb-3'
          }}
          secondaryAction={{
            text: 'Cancel Anyway',
            onClick: cancelAnyway
          }}
          layout="vertical"
        />

        <DowngradeBillingDetailsFooter
          formattedNextBillingDate={formattedNextBillingDate}
          className="pause-details mb-3"
        />
      </div>
    </div>
  );
};

export default GoalAchievedDowngradeOffer;
